import { For, Show } from "solid-js";
import { AmountPill } from "./amount_pill";
import { useDenominationsGridWebstoreTelescopeContext } from "../context/denominations_grid";
import { CustomAmountPill } from "./custom_amount_pill";

export function AmountSelector() {
  const gridState = useDenominationsGridWebstoreTelescopeContext();
  const {
    denominationList,
    internalState,
    setCustomSelected,
    isCustomDenominationAllowed,
    customSelected,
  } = gridState;
  const { selectedAmount, setSelectedAmount } = internalState;

  // Determine columns: 2 if 4 or fewer items, 3 if more than 4
  const totalItems = () =>
    denominationList.length + (isCustomDenominationAllowed ? 1 : 0);
  const columnsCount = () => (totalItems() <= 4 ? 2 : 3);

  return (
    <div
      class="grid w-full gap-3"
      style={{
        "grid-template-columns": `repeat(${columnsCount()}, 1fr)`,
      }}
    >
      <For each={denominationList}>
        {(amount) => (
          <AmountPill
            amount={`₹${amount.toLocaleString()}`}
            isSelected={selectedAmount() === amount}
            onClick={() => {
              setCustomSelected(false);
              setSelectedAmount(amount);
            }}
          />
        )}
      </For>
      <Show when={isCustomDenominationAllowed}>
        <CustomAmountPill
          isSelected={customSelected()}
          onClick={() => {
            setCustomSelected(true);
            document.getElementById("custom-amount-input")?.focus();
            setSelectedAmount(null);
          }}
        />
      </Show>
    </div>
  );
}
